import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily: string; inputControl?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      outerContainer: {
        background: 'transparent',
        height: '833px',
        minWidth: '100%',
        padding: '0px 24px 24px 24px',
        [theme.breakpoints.down('lg')]: {
          height: '1660px'
        }
      },
      innerContainer: {
        background: 'white',
        borderRadius: '8px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        height: '809px',
        minWidth: '100%',
        overflow: 'hidden',
        padding: '32px 64px 32px 64px',
        [theme.breakpoints.down('lg')]: {
          display: 'grid',
          gridTemplateRows: 'min-content min-content auto',
          height: '1640px',
          padding: '32px 0'
        }
      },
      headerContainer: {
        borderBottom: 'solid 2px #c8c8c8',
        padding: '0 0 16px',
        width: '100%',
        [theme.breakpoints.down('lg')]: {
          padding: '0 30px 16px'
        }
      },
      selectedLevelContainer: {
        borderRight: 'solid 2px #c8c8c8',
        fontFamily: props.fontFamily,
        height: '600px',
        padding: '24px 24px 0 0',
        overflow: 'hidden',
        width: '50%',
        [theme.breakpoints.down('lg')]: {
          borderBottom: 'solid 2px #c8c8c8',
          borderRight: 'none',
          height: 'auto',
          maxHeight: '602px',
          padding: '30px',
          width: '100%'
        }
      },
      dataEntryContainer: {
        height: props.inputControl ? '250px' : '600px',
        padding: '12px 0 0 32px',
        width: '50%',
        [theme.breakpoints.down('lg')]: {
          height: 'auto',
          minHeight: props.inputControl ? '250px' : '600px',
          padding: '28px 30px 0',
          // eslint-disable-next-line no-nested-ternary
          paddingBottom: props.inputControl ? (props.inputControl === 'numpad' ? '460px' : '340px') : '0',
          width: '100%'
        }
      },
      membershipLevelName: {
        flex: '1',
        margin: '0px 24px 0 60px'
      },
      membershipTypeName: {
        flex: '1',
        margin: '0px 24px 0 60px'
      },
      inputFieldContainer: {
        padding: '0px 12px',
        [theme.breakpoints.down('lg')]: {
          padding: '0px 24px'
        }
      },
      inputField: {
        [theme.breakpoints.down('lg')]: {
          minWidth: '350px !important',
          fontSize: '30px'
        }
      }
    })
  );
